import { Button } from '@chaser/components';
import React from 'react';
import { bool, string } from 'prop-types';
import { toast } from '../ToastContainer/index';
import copy from 'copy-to-clipboard';

const CopyButton = ({ value, disabled, toastText = 'Value copied!', className }) => {
  return (
    <Button
      appearance="minimal"
      style={{ padding: '0px' }}
      icon="copy"
      onClick={() => {
        copy(value);
        toast.info(toastText);
      }}
      disabled={disabled}
      className={className}
    />
  );
};

CopyButton.propTypes = {
  value: string.isRequired,
  disabled: bool,
  className: string,
};

export default CopyButton;
